import Vue from "vue";
import Router from "vue-router";
import warehouseList from "@/views/warehouseList";
import Login from "@/views/login";
import orderDetail from "@/views/orderDetail";
import salesList from "@/views/salesList";
import agentAddress from "@/views/agentAddress";
import Error from "@/views/error";
import message from "@/views/message";
import billList from "@/views/billList";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/warehouseList",
      name: "warehouseList",
      component: warehouseList,
      meta: {
        title: "仓库出货单"
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        title: "登录",
        noNeedLogin: true
      }
    },
    {
      path: "/orderDetail",
      name: "orderDetail",
      component: orderDetail,
      meta: {
        title: "订单详情"
      }
    },
    {
      path: "/",
      name: "salesList",
      component: salesList,
      meta: {
        title: "销售出货单"
      }
    },
    {
      path: "/agentAddress",
      name: "agentAddress",
      component: agentAddress,
      meta: {
        title: "代理商地址管理"
      }
    },
    {
      path: "/message",
      name: "message",
      component: message,
      meta: {
        title: "短信模板管理"
      }
    },
    {
      path: "/billList",
      name: "billList",
      component: billList,
      meta: {
        title: "出货单管理"
      }
    },
    {
      path: "/error",
      name: "error",
      component: Error,
      meta: {
        title: "出错了"
      }
    }
  ]
});
router.beforeEach((to, from, next) => {
  next();
});
router.afterEach(function(to, from) {
  document.title = to.meta.title; //跳转后设置页面的title
});

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js